import * as React from "react";
const SvgCloseLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.293 18.707a1 1 0 0 1 0-1.414l12-12a1 1 0 1 1 1.414 1.414l-12 12a1 1 0 0 1-1.414 0" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.293 6.707a1 1 0 1 1 1.414-1.414l12 12a1 1 0 0 1-1.414 1.414z" }));
export default SvgCloseLine;
